module.exports = __webpack_public_path__ + "static/craiglist-9091a314bb1e88f82af1b7b056e5cd8b.png";